<template>
  <v-card class="pt-12 px-8 primary darken-1">
    <div v-show="loading" style="height: 300px">
      <loading-animation></loading-animation>
    </div>
    <div v-show="!loading" style="min-height: 300px">
      <v-row class="pt-2">
        <v-col cols="12" class="d-flex align-center">
          <h1 class="title">Área Desmatada</h1>
          <div class="ml-4" v-if="currentData && currentData.length > 0">
            <v-menu attach offset-y>
              <template v-slot:activator="{attrs, on}">
                <v-btn
                  color="primary"
                  width="140"
                  height="28"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                  tile
                  class="export-chart-btn"
                >
                  <span>{{ selectedChartType.text }}</span>
                  <div class="arrow-down"></div>
                </v-btn>
              </template>
              <v-list dense color="#212A35">
                <v-list-item
                  v-for="(item, i) in chartType"
                  :key="i"
                  link
                  @click="generateChart(item)"
                >
                  <v-list-item-title
                    style="color: var(--v-greyd-base); font-size: 14px"
                    >{{ item.text }}</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <v-spacer></v-spacer>
          <chart-export-menu v-if="currentData && currentData.length > 0"
            @fullscreenChart="() => this.$refs.deforestationChartRef.fullscreenChart()"
            @printChart="() => this.$refs.deforestationChartRef.printChart()"
            @exportChart="
              ($event) => this.$refs.deforestationChartRef.exportChart($event)
            "
            @exportCSV="() => this.$refs.deforestationChartRef.exportCSV()"
            @exportXLS="() => this.$refs.deforestationChartRef.exportXLS()"
          >
          </chart-export-menu>
        </v-col>
      </v-row>
      <v-row class="pt-2">
        <v-col cols="12">
          <column-deforestation-chart
            v-show="currentData && currentData.length > 0"
            ref="deforestationChartRef"
          ></column-deforestation-chart>
          <v-card-text v-if="!currentData || currentData.length == 0">
          <span class="secondary&#45;&#45;text text&#45;&#45;lighten-1 textNoData">
              Sem dados para SIA.
          </span>
          </v-card-text>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import ColumnDeforestationChart from './DeforestationCharts/ColumnDeforestationChart.vue';
import LoadingAnimation from '../common/LoadingAnimation.vue';
import ChartExportMenu from '../common/ChartExportMenu.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    ColumnDeforestationChart,
    LoadingAnimation,
    ChartExportMenu,
  },
  data: () => ({
    chartType: [
      {id: 1, text: 'Anual'},
      {id: 2, text: 'Semestral'},
      {id: 3, text: 'Trimestral'},
      {id: 4, text: 'Mensal'},
    ],
    selectedChartType: {id: 1, text: 'Anual'},
    loading: false,
    currentData: null,
  }),
  computed: {
    ...mapGetters(['saneparLocations']),
  },
  watch: {
    async saneparLocations() {
      if (this.saneparLocations) {
        await this.initializeDeforestation();
      }
    }
  },
  async mounted() {
    if (this.saneparLocations.length > 0) {
      await this.initializeDeforestation();
    }
  },
  methods: {
    async initializeDeforestation() {
      this.loading = true;
      await this.generateChart({id: 1, text: 'Anual'});
      this.loading = false;
    },

    async generateChart(item) {
      this.selectedChartType = item;
      switch (item.id) {
        case 1:
          await this.createAnualChart();
          return;
        case 2:
          await this.createSemestralChart();
          return;
        case 3:
          await this.createTrimestralChart();
          return;
        case 4:
          await this.createMensalChart();
          return;
        default:
          break;
      }
    },

    async createAnualChart() {
      await this.$store.dispatch('loadDesmatamentosData', {
        sia: this.saneparLocations[0]?.acronym,
        type: 'anual',
      });
      const data = await this.$store.getters.desmatamentosData;
      this.currentData = data;
      if (data.length > 0) {
        var categories = [];
        var valores = [];
        for (let d in data) {
          categories.push(data[d].ano);
          valores.push(data[d].somaArea);
        }
        const series = [
          {
            name: 'Somatório Ano',
            data: valores,
            color: '#E17536',
            dataLabels: [
              {
                enabled: true,
                verticalAlign: 'bottom',
                format: '{y}',
              },
            ],
          },
        ];
        let options = {};
        options['exporting_title'] = this.saneparLocations[0]?.locationName;
        await this.$refs.deforestationChartRef.createChart(categories, series, options);
      }
    },

    async createSemestralChart() {
      await this.$store.dispatch('loadDesmatamentosData', {
        sia: this.saneparLocations[0]?.acronym,
        type: 'semestral',
      });
      const data = await this.$store.getters.desmatamentosData;
      this.currentData = data;
      if (data.length > 0) {
        const startYear = data[0].ano;
        const endYear = data[data.length-1].ano;
        let values = this.initFillData(startYear, endYear);

        for (let d in data) {
          values[data[d].ano][data[d].semestre] = data[d].somaArea;
        }

        const semestres = [
          'Semestre 01',
          'Semestre 02',
        ];
        const categories = Object.keys(values);
        const series = [];
        for (let i = 0; i <= semestres.length - 1; i++) {
          series.push({
            name: semestres[i],
            data: this.getValuesByCategoryYearIndex(values, i+1),
            color: '#E17536',
            dataLabels: [
              {
                enabled: true,
                formatter: function () {
                  return this.series.name;
                },
                inside: true,
                verticalAlign: 'bottom',
                rotation: 0,
                color: '#212A35',
                style: {
                  fontWeight: 'bold',
                },
              },
              {
                enabled: true,
                verticalAlign: 'bottom',
                format: '{y}',
              },
            ],
          });
        }
        let options = {};
        options['exporting_title'] = this.saneparLocations[0]?.locationName;
        await this.$refs.deforestationChartRef.createChart(categories, series, options);
      }
    },

    async createTrimestralChart() {
      await this.$store.dispatch('loadDesmatamentosData', {
        sia: this.saneparLocations[0]?.acronym,
        type: 'trimestral',
      });
      const data = await this.$store.getters.desmatamentosData;
      this.currentData = data;
      if (data.length > 0) {
        const startYear = data[0].ano;
        const endYear = data[data.length-1].ano;
        let values = this.initFillData(startYear, endYear);

        for (let d in data) {
          values[data[d].ano][data[d].trimestre] = data[d].somaArea;
        }

        const trimestres = [
          'Tri 01',
          'Tri 02',
          'Tri 03',
          'Tri 04',
        ];
        const categories = Object.keys(values);
        const series = [];
        for (let i = 0; i <= trimestres.length - 1; i++) {
          series.push({
            name: trimestres[i],
            data: this.getValuesByCategoryYearIndex(values, i+1),
            color: '#E17536',
            dataLabels: [
              {
                enabled: true,
                formatter: function () {
                  return this.series.name;
                },
                inside: true,
                verticalAlign: 'bottom',
                rotation: 0,
                color: '#212A35',
                style: {
                  fontWeight: 'bold',
                },
              },
              {
                enabled: true,
                verticalAlign: 'bottom',
                format: '{y}',
              },
            ],
          });
        }
        let options = {};
        options['exporting_title'] = this.saneparLocations[0]?.locationName;
        await this.$refs.deforestationChartRef.createChart(categories, series, options);
      }
    },

    async createMensalChart() {
      await this.$store.dispatch('loadDesmatamentosData', {
        sia: this.saneparLocations[0]?.acronym,
        type: 'mensal',
      });
      const data = await this.$store.getters.desmatamentosData;
      this.currentData = data;
      if (data.length > 0) {
        const startYear = data[0].ano;
        const endYear = data[data.length-1].ano;
        let values = this.initFillData(startYear, endYear);

        for (let d in data) {
          values[data[d].ano][data[d].mes] = data[d].somaArea;
        }

        const meses = [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ];
        const categories = Object.keys(values);
        const series = [];
        for (let i = 0; i <= meses.length - 1; i++) {
          series.push({
            name: meses[i],
            data: this.getValuesByCategoryYearIndex(values, i+1), // [dado_mesano1, dado_mesano2,..,dado_mesanoN]
            color: '#E17536',
            dataLabels: [
              {
                enabled: true,
                formatter: function () {
                  return this.series.name;
                },
                inside: true,
                rotation: -90,
                color: '#212A35',
                style: {
                  fontWeight: 'bold',
                },
              },
              {
                enabled: true,
                verticalAlign: 'bottom',
                format: '{y}',
              },
            ],
          });
        }
        let options = {};
        options['exporting_title'] = this.saneparLocations[0]?.locationName;
        await this.$refs.deforestationChartRef.createChart(categories, series, options);
      }
    },

    initFillData(startYear, endYear) {
      let values = {};
      for (let y = startYear; y <= endYear; y++) {
        values[y] = [];
        for (let i = 1; i <= 2; i++) {
          values[y].push(null);
        }
      }
      return values;
    },

    getValuesByCategoryYearIndex(values, index) {
      let results = [];
      for (let year in values) {
        const v = values[year][index];
        if (v) {
          results.push(v);
        }
        else {
          results.push(null);
        }
      }
      return results;
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  color: #fff;
  font-family: Roboto;
  font-size: 20.8px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
}
.export-chart-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #8792d5;

  span {
    color: #95a1ec;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: none;
    letter-spacing: normal;
  }
}
.arrow-down {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 10px solid #8792d5;
  margin-left: 12px;
}
.textNoData {
  color: #95A1EC;
  font-size: 14px;
  font-family: Roboto;
  font-style: italic;
  font-weight: 300;
  line-height: 20px;
  margin-bottom: 20px;
}
@media screen {
	.highcharts-title {display: none;}
}
@media print {
	.highcharts-title {display: block;}
}
</style>
